var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3000,
    height: 2400,
    viewBox: "0 0 3000 2400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1500 1800V2400H900V1920L1500 1800Z",
    fill: "#9A100D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2400H400V2020L1500 1800V0L0 1200V2400ZM400 1640L900 1440V960L400 1260V1640Z",
    fill: "#DBDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3000 2400H2600V2020L2100 1920V2400H1500V0L3000 1200V2400ZM2600 1640L2100 1440V960L2600 1260V1640Z",
    fill: "#E4120E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2100 2400H2600V2020L2100 1920V2400Z",
    fill: "#9A100D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2100 1440L2600 1640V1260L2100 960V1440Z",
    fill: "#9A100D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M400 1260L900 960V1399.02L400 1260Z",
    fill: "#232323"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2600 1260L2100 960V1399.02L2600 1260Z",
    fill: "#232323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2100 2066.34L2600 2020L2100 1920V2066.34Z",
    fill: "#232323"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M900 2066.34L400 2020L900 1920V2066.34Z",
    fill: "#232323"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M900 2400H400V2020L900 2066.34V2400Z",
    fill: "#9F9F9F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M400 1640L900 1440V1399.02L400 1260V1640Z",
    fill: "#9F9F9F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M613.265 1554.69L900 1440V1399.02L400 1260L613.265 1554.69Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2386.73 1554.69L2100 1440V1399.02L2600 1260L2386.73 1554.69Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2600 2020L2325 2400H2100V2066.34L2600 2020Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M400 2020L675 2400H900V2066.34L400 2020Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.4cdc3958b7c39d3fdda85a73721ba138.svg";
export { ForwardRef as ReactComponent };